// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { forklift16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-forklift': IconForklift;
    }
}

/**
 * The icon component for the 'forklift' icon
 */
export class IconForklift extends IconSvg {
    public constructor() {
        super(forklift16X16);
    }
}

registerIconSvg('icon-forklift', IconForklift);
export const iconForkliftTag = 'nimble-icon-forklift';
